<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="weui-cells__title">选择存货计价方式</div>

      <div class="weui-cells weui-cells_radio">
        <label class="weui-cell weui-cell_active weui-check__label">
          <div class="weui-cell__bd">
            <p>加权平均法</p>
          </div>
          <div class="weui-cell__ft">
            <input type="radio" class="weui-check" name="value" value="WACC" v-model="value" />
            <span class="weui-icon-checked"></span>
          </div>
        </label>
        <label class="weui-cell weui-cell_active weui-check__label">
          <div class="weui-cell__bd">
            <p>先进先出法</p>
          </div>
          <div class="weui-cell__ft">
            <input type="radio" class="weui-check" name="value" value="FIFO" v-model="value" />
            <span class="weui-icon-checked"></span>
          </div>
        </label>
      </div>

      <div class="weui-cells__title">修改后将重置未结账月份库存成本</div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="save">保存</a>
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
      >取消</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      baseUrl: "/api/commons/configs",
      value: "FIFO"
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.loadData();
    });
  },
  methods: {
    loadData() {
      var me = this;
      me.$loading({
        url: me.baseUrl + "/getConfigByCode",
        params: {
          code: "cucaltor"
        }
      }).then(function(res) {
        if (res.success) {
          if (res.data.data) {
            me.value = res.data.data;
          }
        } else {
          me.$weui.topTips(res.message, 3000);
        }
      });
    },
    save() {
      var me = this,
        value = me.value,
        title = { WACC: "加权平均法", FIFO: "先进先出法" }[value];
      me.$weui.confirm(`确定使用 ${title}？`, function() {
        me.$loading({
          url: me.baseUrl + "/update",
          method: "POST",
          jsonData: [
            {
              code: "cucaltor",
              data: value
            }
          ]
        })
          .then(function(res) {
            if (res.success) {
              me.$weui.toast("设置成功", 2000);
              me.$router.back();
            } else {
              me.$weui.topTips(res.message, 3000);
            }
          })
          .catch(function() {
            me.$weui.topTips("设置失败", 3000);
          });
      });
    }
  }
};
</script>